import { render } from "./paySignUpApply.vue?vue&type=template&id=0c099bed&scoped=true"
import script from "./paySignUpApply.vue?vue&type=script&lang=js"
export * from "./paySignUpApply.vue?vue&type=script&lang=js"

import "./paySignUpApply.vue?vue&type=style&index=0&id=0c099bed&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c099bed"]])

export default __exports__